/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Geo_Dim_Machine_ReadabilityInputs */

const en_directory_detail_signals_geo_dim_machine_readability = /** @type {(inputs: Directory_Detail_Signals_Geo_Dim_Machine_ReadabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machine readability`)
};

const zh_directory_detail_signals_geo_dim_machine_readability = /** @type {(inputs: Directory_Detail_Signals_Geo_Dim_Machine_ReadabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`机器可读性`)
};

/**
* | output |
* | --- |
* | "Machine readability" |
*
* @param {Directory_Detail_Signals_Geo_Dim_Machine_ReadabilityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_geo_dim_machine_readability = /** @type {((inputs?: Directory_Detail_Signals_Geo_Dim_Machine_ReadabilityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Geo_Dim_Machine_ReadabilityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_geo_dim_machine_readability(inputs)
	return zh_directory_detail_signals_geo_dim_machine_readability(inputs)
});
export { directory_detail_signals_geo_dim_machine_readability as "directory.detail.signals.geo_dim.machine_readability" }